import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { format, subMonths } from 'date-fns';

import { show } from 'store/modules/dialog/actions';
import { Setor, Status, StatusArquivo, Tipo } from 'utils/variables';
import api from 'services/api';
import { useModal } from 'hooks/modal';

import Card from 'components/Card';
import Button from 'components/Button';
import Input from 'components/Input';
import Radio from 'components/Radio';
import Checkbox from 'components/Checkbox';
import Select from 'components/Select';
import AsyncSelectCreatable from 'components/AsyncSelectCreatable';
import Spinner from 'components/Spinner';
import DatePicker from 'components/DatePicker';
import TextArea from 'components/TextArea';
import Tooltip from 'components/Tooltip';

import { FiArrowLeft, FiInfo } from 'react-icons/fi';
import { MdFiberNew } from 'react-icons/md';
import {
  Container,
  Content,
  Form,
  FormContent,
  FormActions,
  ColumnContent,
  Scroll,
  DadosPatrocinio,
  DadosLocucao,
} from './styles';

import { FormHandles } from '@unform/core';
import {
  ChamadaEmissora,
  Comercial,
  Emissora,
  Patrocinio,
  Programa,
  Usuario,
  Chamada,
  Cliente,
  Agencia,
} from 'pages/@types';
import AppError from 'utils/AppError';
import getValidationErrors from 'services/getValidationErros';
import Switch from 'components/Switch';
import Loader from 'components/ContentLoader/GenericLoader';
import Vinheta from './vinheta';

export interface PatrocinioOption extends Patrocinio {
  value: string;
  label: string;
  cliente: string;
  agencia: string;
  locucao?: string;
  duracao: string;
  __isNew__: boolean;
  preview_url?: string;
  thumbnail_url?: string;
  ordem: number;
}

export interface EmissoraOption {
  id: number;
  label: string;
  value: string;
}

export interface BasePrograma {
  id: number | null;
  nome: string;
  duracao: number;
  locucao: string;
  emissora: string;
  preview_url: string;
  thumbnail_url: string;
  programa?: Programa;
}
interface SelectOption {
  value: string;
  label: string;
  locucaobase?: string | null;
}

interface Tipo {
  id: string;
  value: string;
}
// configuração do validator
const baseSchema = Yup.object().shape({
  retranca: Yup.string()
    .required('Campo Obrigatório')
    .matches(/^[a-zA-Z0-9- .()/]*$/, 'Retranca contém caracteres especiais')
    .max(26, 'Retranca excedeu o limite de 26 caracteres'),
  duracao: Yup.number()
    .typeError('Duração deve ser um número')
    .min(3)
    .required('Campo Obrigatório'),
  web: Yup.string()
    .nullable()
    .required('Campo Obrigatório'),
  tipo: Yup.string()
    .nullable()
    .required('Campo Obrigatório'),
  setor: Yup.string()
    .nullable()
    .required('Campo Obrigatório'),
  emissora: Yup.string().required('Escolha pelo menos uma exibidora'),
  patrocinios: Yup.array().min(0),
  ancine: Yup.string().matches(/^[0-9- ./]*$/, 'Ancine deve ser um número'),
});
const schemaOpec = baseSchema.shape({
  datainicio: Yup.date()
    .required('Campo Obrigatório')
    .typeError('Data início da veiculação inválida'),
  datafim: Yup.date()
    .required('Campo Obrigatório')
    .typeError('Data fim da veiculação inválida'),
  codmaterial: Yup.string()
    .transform(value => value || undefined)
    .min(5, 'O Código Material deve ter de 5 a 6 dígitos')
    .max(6, 'O Código Material deve ter de 5 a 6 dígitos')
    .matches(/^[0-9- ./]*$/, 'O Código Material deve ser um número')
    .required('Campo Obrigatório'),
});

const schemaProg = baseSchema.shape({
  codmaterial: Yup.string()
    .transform(value => value || undefined)
    .min(5, 'O Código Material deve ter de 5 a 6 dígitos')
    .max(6, 'O Código Material deve ter de 5 a 6 dígitos')
    .matches(/^[0-9- ./]*$/, 'O Código Material deve ser um número'),
});
const schemaVhPromo = schemaOpec.shape({
  locucaobase: Yup.string().required('Campo obrigatório'),
  locucaopatrocinio_1: Yup.string().when('locucaopatrocinio_2', {
    is: locucaopatrocinio_2 => !locucaopatrocinio_2, // Verifica se não possuí locução do terceiro patrocínio
    then: Yup.string().matches(
      /^E /,
      'O último patrocínio deve começar com "E "',
    ), // Se não possuir, a locução do segundo patrocínio deve comerçar com "E "
  }),
  locucaopatrocinio_2: Yup.string().when('locucaopatrocinio_3', {
    is: locucaopatrocinio_3 => !locucaopatrocinio_3, // Verifica se não possuí locução do terceiro patrocínio
    then: Yup.string().matches(
      /^E /,
      'O último patrocínio deve começar com "E "',
    ), // Se não possuir, a locução do segundo patrocínio deve comerçar com "E "
  }),
  locucaopatrocinio_3: Yup.string().matches(
    /^E /,
    'O último patrocínio deve começar com "E "',
  ),
});
export default function Chamadas() {
  // redux
  const { profile } = useSelector((state: any) => state.usuario);
  const dispatch = useDispatch();

  // react-router-dom
  const navigate = useNavigate();

  /**
   * USE STATE
   */
  const [emissoras, setEmissoras] = useState<EmissoraOption[]>([]);
  const [materialRede, setMaterialRede] = useState(false);
  const [setor, setSetor] = useState('');
  const [programas, setProgramas] = useState<SelectOption[]>([]);
  const [clientes, setClientes] = useState<SelectOption[]>([]);
  const [agencias, setAgencias] = useState<SelectOption[]>([]);
  const [comunicadores, setComunicadores] = useState([]);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingOptions, setLoadingOptions] = useState(true);
  const [loading, setLoading] = useState(false);
  const [tipo, setTipo] = useState<Tipo>({ id: '', value: '' });
  const [patrocinios, setPatrocinios] = useState<PatrocinioOption[]>([]);
  const [asyncLoading, setAsyncLoading] = useState(false);
  const [previa, setPrevia] = useState(false);
  const [basePrograma, setBasePrograma] = useState<BasePrograma>();
  const [initialData, setInitialData] = useState({
    id: 0,
    retranca: '',
    programa: null,
    tipo: '',
    setor:
      profile.setor === 'promo' || profile.setor === 'hub' ? profile.setor : '',
    emissora: [],
    web: true,
    gerarclaquete: true,
    encerrada: false,
    previa: false,
    arquivo: false,
    statusarquivo: 'NA',
    midia: null,
    locucaobase: '',
    observacaocomercial: '',
    observacaolocucao: '',
  });

  /**
   * USE PARAMS
   */
  const { chamadaId } = useParams<{ chamadaId: string }>();

  const tipos = [
    { id: 'chamada', label: 'Chamada', disabled: profile.setor === Setor.OPEC },
    { id: 'vinheta', label: 'Vinheta' },
    {
      id: 'promocional',
      label: 'Promocional',
      disabled: profile.setor === Setor.OPEC,
    },
    {
      id: 'chpatrocinada',
      label: 'Chamada Patrocinada',
    },
    { id: 'apoio', label: 'Apoio' },
    {
      id: 'campanha',
      label: 'Campanha Inst',
      disabled: profile.setor === Setor.OPEC,
    },
    { id: 'campanhapatrocinada', label: 'Campanha Patrocinada' },
    { id: 'videopatrocinado', label: 'Video Patrocinado' },
    { id: 'programete', label: 'Programete' },
    {
      id: 'afinacao',
      label: 'Afinação',
      disabled: profile.setor === Setor.OPEC,
    },
  ];

  /**
   * Hooks
   */
  const { showModal, hideModal } = useModal();

  /**
   * USE REF
   */
  const formRef = useRef<FormHandles>(null);

  /**
   * USE CALLBACK
   */
  const handleSelectedExibidor = useCallback(() => {
    if (
      formRef.current &&
      formRef.current.getFieldValue('emissora').length === 8
    )
      setMaterialRede(true);
  }, []);

  const handleToogleEmissoras = useCallback(
    e => {
      e.preventDefault();
      if (formRef.current) {
        if (formRef.current.getFieldValue('emissora').length === 8) {
          formRef.current.clearField('emissora');
          setMaterialRede(false);
        } else {
          formRef.current.setFieldValue(
            'emissora',
            emissoras.map((emi: EmissoraOption) => emi.id).join(),
          );
          setMaterialRede(true);
        }
      }
    },
    [emissoras],
  );

  const handleMessage = useCallback(
    ({ contentHTML, redirectTo, type }) => {
      const option = {
        type: type,
        confirmButtonText: '',
        contentHTML,
        timer: 3000,
        cancelButtonText: 'NÃO',
        redirectTo,
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: true,
      };

      dispatch(show(option));
    },
    [dispatch],
  );

  const loadComerciais = useCallback(async value => {
    if (value.length > 2) {
      setAsyncLoading(true);
      const response = await api.get('/comerciais', {
        params: { codmaterial: value },
      });
      setAsyncLoading(false);

      return response.data.comerciais.map((mat: Comercial) => ({
        ...mat,
        value: mat.id,
        label: `${mat.codmaterial} - ${mat.titulo} `,
        agencia: mat.agencia ? mat.agencia.mnemonico : `SEM AGÊNCIA`,
        cliente: mat.cliente ? mat.cliente.mnemonico : 'SEM CLIENTE',
        isDisabled: mat.statusdownload === 'indisponivel',
        preview_url: mat.midia?.preview_url,
        thumbnail_url: mat.midia?.thumbnail_url,
        created_at: null,
      }));
    }
  }, []);

  const disableEdit = useCallback(
    (ch: Chamada) => {
      if (
        [Status.ENTREGUE, Status.FINALIZADO].includes(ch.status) ||
        (profile.setor === Setor.OPEC && ch.tipo === Tipo.VINHETA && ch.midia)
      )
        handleMessage({
          contentHTML: `<h3>Você não tem permissão para editar essa chamada!</h3> <p>Você será redirecionado em 3 segundos</p>`,
          redirectTo: 'goBack',
          type: 'error',
        });
    },
    [handleMessage, profile.setor],
  );
  /**
   * USE EFFECT
   */
  useEffect(() => {
    async function loadChamada() {
      setLoading(true);
      try {
        const response = await api.get(`/chamadasts/${chamadaId}`);

        disableEdit(response.data);
        let _patrocinios: PatrocinioOption[] = [];
        if (
          !!response.data.chamada.patrocinios &&
          response.data.chamada.patrocinios.length > 0
        ) {
          _patrocinios = response.data.chamada.patrocinios
            .map((patro: Patrocinio) => {
              return {
                ...patro,
                duracao: patro.comercial ? patro.comercial.duracao : null,
                agencia:
                  patro.comercial && patro.comercial.agencia
                    ? patro.comercial.agencia.mnemonico
                    : `SEM AGÊNCIA`,
                cliente:
                  patro.comercial && patro.comercial.cliente
                    ? `${patro.comercial.cliente.mnemonico}`
                    : `SEM CLIENTE`,
                value: patro.comercial?.id || patro.codmaterial,
                label: patro.comercial
                  ? `${patro.comercial.codmaterial} - ${patro.comercial.titulo}`
                  : patro.codmaterial,
                __isNew__: !patro.comercial,
                preview_url: patro.comercial?.midia?.preview_url,
                thumbnail_url: patro.comercial?.midia?.thumbnail_url,
                ordem: patro.ordem || 0,
                created_at: null,
              };
            })
            .sort((a, b) => a.ordem - b.ordem);
        }
        setMaterialRede(response.data.chamada.chamadaemissora.length === 8);
        const programa = response.data.chamada.programa;
        const patrocinioFields: Record<string, any> = {};

        _patrocinios.forEach((p, index) => {
          patrocinioFields[`patrociniosvinhetas_${index}`] = p;
          patrocinioFields[`locucaopatrocinio_${index}`] = p.locucao;
        });
        setInitialData({
          ...response.data.chamada,
          programa: programa
            ? {
                value: programa.id,
                label:
                  (programa.sigla ? programa.sigla + ' - ' : '') +
                  (programa.mnemonico ? programa.mnemonico : '') +
                  (programa.nome ? ' (' + programa.nome + ')' : ''),
              }
            : null,
          ...(response.data.chamada.cliente && {
            cliente: {
              value: response.data.chamada.cliente.id,
              label: response.data.chamada.cliente.mnemonico,
            },
          }),
          ...(response.data.chamada.agencia && {
            agencia: {
              value: response.data.chamada.agencia.id,
              label: response.data.chamada.agencia.mnemonico,
            },
          }),
          encerrada:
            response.data.chamada.status === Status.FINALIZADO ||
            response.data.chamada.status === Status.ENTREGUE,
          web: response.data.chamada.web !== 'semweb',
          datainicio: response.data.chamada.datainicio
            ? new Date(response.data.chamada.datainicio)
            : null,
          datafim: response.data.chamada.datafim
            ? new Date(response.data.chamada.datafim)
            : null,
          emissora: response.data.chamada.chamadaemissora
            ? response.data.chamada.chamadaemissora.map(
                (emi: ChamadaEmissora) => emi.emissora.id,
              )
            : [],
          codmaterial: response.data.chamada.codmaterial,
          patrocinios: _patrocinios,
          comunicador: response.data.chamada.comunicador
            ? {
                value: response.data.chamada.comunicador.id,
                label: response.data.chamada.comunicador.nome,
              }
            : null,
          arquivo: response.data.chamada.statusarquivo !== 'NA',
          ...patrocinioFields,
        });
        setPatrocinios(_patrocinios);
        setTipo({
          id: response.data.chamada.tipo,
          value: response.data.chamada.tipo,
        });
        setSetor(response.data.chamada.setor);
        const _baseprograma = response.data.chamada.baseprograma;
        if (_baseprograma) {
          setBasePrograma({
            ..._baseprograma,
            emissora: _baseprograma.emissora?.nome || 'REDE',
            nome: _baseprograma.programa.mnemonico,
            locucao:
              response.data.chamada.locucaobase ||
              _baseprograma.programa.locucaobase,
          });
        }
      } catch (error) {
        if (error instanceof Error) {
          toast.error(error.message);
        } else {
          const appError = error as AppError;
          toast.error(appError.message);
        }
      }
      setLoading(false);
    }

    if (chamadaId) {
      loadChamada();
    }
  }, [chamadaId, disableEdit]);

  useEffect(() => {
    async function loadOptions() {
      try {
        const [
          responseUsuarios,
          responseClientes,
          responseAgencias,
          responseProgramas,
          responseEmissoras,
        ] = await Promise.all([
          api.get('/usuarios', {
            params: { locucao: true },
          }),
          api.get('/clientes'),
          api.get('/agencias'),
          api.get('/programas'),
          api.get('/emissoras'),
        ]);
        if (
          responseUsuarios &&
          responseUsuarios.data &&
          responseClientes &&
          responseClientes.data &&
          responseAgencias &&
          responseAgencias.data &&
          responseProgramas &&
          responseProgramas.data &&
          responseEmissoras &&
          responseEmissoras.data
        ) {
          setComunicadores(
            responseUsuarios.data.docs.map((usu: Usuario) => ({
              value: usu.id,
              label: usu.nome,
              isDisabled: usu.status === 'inativo',
              ...usu,
            })),
          );
          setEmissoras(
            responseEmissoras.data.map((emi: Emissora) => {
              return { id: emi.id, label: emi.nome };
            }),
          );
          setClientes(
            responseClientes.data.map((cliente: Cliente) => {
              return {
                value: cliente.id,
                label: cliente.mnemonico,
              };
            }),
          );
          setAgencias(
            responseAgencias.data.map((agencia: Agencia) => {
              return {
                value: agencia.id,
                label: agencia.mnemonico,
              };
            }),
          );
          setProgramas(
            responseProgramas.data.map((pgm: Programa) => {
              return {
                locucaobase: pgm.locucaobase,
                value: pgm.id,
                label:
                  (pgm.sigla ? pgm.sigla + ' - ' : '') +
                  (pgm.mnemonico ? pgm.mnemonico : '') +
                  (pgm.nome ? ' (' + pgm.nome + ')' : ''),
              };
            }),
          );
        } else toast.error('Falha de comunicação com o sistema');
        setLoadingOptions(false);
      } catch (e) {
        if (e instanceof Error) toast.error(e.message);
        else if (e instanceof AppError) toast.error(e.message);
        else {
          const appError = e as AppError;
          if (appError.message) toast.error(appError.message);
          else toast.error('Erro inesperado');
        }
      }
    }
    loadOptions();
  }, []);

  const normalizeDataToBackend = useCallback(
    (_data: any, _patrocinios: PatrocinioOption[]) => {
      return Object.assign({
        ..._data,
        emissora: _data.emissora ? _data.emissora : '',
        duracao: parseInt(_data.duracao),
        programa_id: _data.programa ? _data.programa : null,
        cliente_id: _data.cliente ? _data.cliente : null,
        ...(_data.agencia && { agencia_id: _data.agencia }),
        comunicador_id: _data.comunicador ? _data.comunicador : null,
        baseprograma_id: basePrograma?.id || null,
        // Caso a base seja limpa, é necessário também limpar a locucao base
        locucaobase: _data.locucaobase || null,
        web: _data.web,
        codmaterial: _data.codmaterial ? Number(_data.codmaterial) : null,
        patrocinios:
          !!_patrocinios && _patrocinios.length > 0
            ? _patrocinios.map((vh, id) => {
                return {
                  codmaterial: vh.__isNew__
                    ? parseInt(vh.value)
                    : vh.codmaterial,
                  comercial_id: vh.__isNew__ ? null : vh.value,
                  locucao: _data[`locucaopatrocinio_${id}`],
                  ordem: id,
                };
              })
            : [],
      });
    },
    [basePrograma],
  );

  const handleSuccessMessage = useCallback(
    (id: number) => {
      const option = {
        type: 'success',
        confirmButtonText: '',
        contentHTML: `<h3>Chamada ${
          chamadaId ? 'editada' : 'criada'
        }!</h3> <p>Você será redirecionado para o Kanban em 3 segundos</p>`,
        timer: 3000,
        cancelButtonText: 'NÃO',
        redirectTo:
          profile.setor === Setor.OPEC ? '/promos' : `/chamadas/${id}/kanban`,
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: true,
      };

      dispatch(show(option));
    },
    [chamadaId, dispatch, profile.setor],
  );
  // submit de salvar prévia para a opec
  const submit = useCallback(
    async data => {
      const response = chamadaId
        ? await api.put(`/chamadas/${chamadaId}`, { previa, ...data })
        : await api.post('/chamadas', { previa, ...data });

      setLoadingSubmit(true);
      if (response && response.data && response.data.id)
        handleSuccessMessage(response.data.id);
      else toast.error('Falha de comunicação com o sistema');
    },
    [chamadaId, handleSuccessMessage, previa],
  );

  const handleVerificaCM = useCallback(
    async data => {
      if (profile.setor === Setor.OPEC) {
        // Verifica se o CM está em uso por outro comercial
        const response = await api.get<Comercial[]>(`/comerciaists`, {
          params: {
            search: data.codmaterial,
            minDate: format(subMonths(new Date(), 3), 'yyyy-MM-dd'),
          },
        });
        if (response && response.data && response.data.length) {
          const comerciais = response.data;
          showModal({
            title: `O CM ${data.codmaterial} já está em uso pelo(s) material(s) abaixo:`,
            component: (
              <div>
                {comerciais.map(c => (
                  <p key={`cm${c.id}`}>
                    ID: {c.id} - TÍTULO: {c.titulo} ({c.cliente.mnemonico}) -
                    DE: {format(new Date(c.created_at), 'dd/MM/yyyy')}
                  </p>
                ))}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '2rem',
                  }}
                >
                  <Button
                    color="default"
                    onClick={() => {
                      hideModal();
                    }}
                  >
                    CANCELAR
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    onClick={() => {
                      hideModal();
                      submit(data);
                    }}
                  >
                    PROSSEGUIR
                  </Button>
                </div>
              </div>
            ),
          });
          return;
        }
      }
      submit(data);
    },
    [profile.setor, submit, showModal, hideModal],
  );

  const handleSubmit = useCallback(
    async (_data: Chamada) => {
      setLoadingSubmit(true);
      try {
        if (formRef.current) {
          if (_data.setor === Setor.PROMO && _data.tipo === Tipo.VINHETA)
            await schemaVhPromo.validate({ ..._data }, { abortEarly: false });
          else if (profile.setor === Setor.OPEC)
            await schemaOpec.validate({ ..._data }, { abortEarly: false });
          else await schemaProg.validate({ ..._data }, { abortEarly: false });
          formRef.current.setErrors({});
          await schemaProg.validate({ ..._data }, { abortEarly: false });
          const data = normalizeDataToBackend(_data, patrocinios);
          await handleVerificaCM(data);
        }
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          if (formRef.current) formRef.current.setErrors(errors);
          toast.error(err.message);
        } else if (err instanceof Error) {
          toast.error(err.message);
        } else {
          const appError = err as AppError;
          toast.error(appError.message);
        }
      }
      setLoadingSubmit(false);
    },
    [handleVerificaCM, patrocinios, profile.setor, basePrograma],
  );

  function handleCreatePatrocinios(inputValue: string) {
    if (inputValue.length >= 5 && inputValue.length <= 6) {
      return true;
    }
  }

  function handleSelectedPatrocinios(value: PatrocinioOption[]) {
    setPatrocinios(value);
  }

  return (
    <Container>
      <header>
        <Button
          color="primary"
          onClick={e => {
            e.preventDefault();
            navigate(-1);
          }}
        >
          VOLTAR
          <FiArrowLeft />
        </Button>
      </header>
      <Card>
        <header>
          {/* {loading ? (
            <h4>CHAMADA</h4>
          ) : (
            <h4>
              {initialData.retranca
                ? 'EDITAR CHAMADA'
                : 'ADICIONAR NOVA CHAMADA'}
            </h4>
          )} */}
          {chamadaId ? (
            <h4>EDITAR CHAMADA</h4>
          ) : (
            <h4>ADICIONAR NOVA CHAMADA</h4>
          )}
        </header>
        <Content>
          <Form
            ref={formRef}
            initialData={initialData}
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <Scroll height="calc(100vh - 280px)">
              {loading ? (
                <Loader />
              ) : (
                <FormContent>
                  <section>
                    <h5>Dados gerais: </h5>
                  </section>
                  <div>
                    <ColumnContent columns="1fr 1fr">
                      <Input
                        name="retranca"
                        placeholder="Retranca *"
                        max={26}
                        disabled={
                          loading || loadingSubmit || initialData.encerrada
                        }
                      />
                      <Input
                        name="descricao"
                        placeholder="Descricao"
                        disabled={
                          loading ||
                          loadingSubmit ||
                          initialData.encerrada ||
                          profile.setor === Setor.OPEC
                        }
                      />
                    </ColumnContent>
                    <ColumnContent columns="1fr 2fr 3fr">
                      <Input
                        name="duracao"
                        type="number"
                        placeholder="Duração *"
                        disabled={
                          loading || loadingSubmit || initialData.encerrada
                        }
                      />
                      <Select
                        errorField=""
                        name="programa"
                        placeholder="Selecione um programa ..."
                        options={programas}
                        isSearchable
                        isClearable
                        disabled={
                          loading || loadingSubmit || initialData.encerrada
                        }
                        fill={false}
                        onChange={value => {
                          setBasePrograma({
                            id: 0,
                            nome: '',
                            duracao: 0,
                            locucao: '',
                            emissora: '',
                            preview_url: '',
                            thumbnail_url: '',
                          });
                          if (formRef.current)
                            formRef.current.setFieldValue(
                              'locucaobase',
                              value?.locucaobase || null,
                            );
                          setInitialData(prevState => ({
                            ...prevState,
                            locucaobase: value?.locucaobase || null,
                          }));
                        }}
                      />
                      <Input
                        name="ancine"
                        placeholder="Ancine"
                        disabled={
                          loadingOptions ||
                          loading ||
                          loadingSubmit ||
                          initialData.encerrada
                        }
                      />
                    </ColumnContent>
                  </div>
                  <ColumnContent columns="1fr 1fr">
                    <div>
                      <section>
                        <h5>Período de veiculação:</h5>
                      </section>
                      <ColumnContent columns="1fr 1fr 4fr">
                        <DatePicker
                          placeholderText="DE"
                          minDate={new Date()}
                          name="datainicio"
                          disabled={
                            loading || loadingSubmit || initialData.encerrada
                          }
                        />

                        <DatePicker
                          placeholderText="ATÉ"
                          minDate={new Date()}
                          name="datafim"
                          disabled={
                            loading || loadingSubmit || initialData.encerrada
                          }
                        />
                      </ColumnContent>
                    </div>
                    {tipo.id &&
                      tipo.id !== Tipo.CHAMADA &&
                      tipo.id !== Tipo.AFINACAO && (
                        <div>
                          <ColumnContent columns="1fr 1fr">
                            <div>
                              <section>
                                <h5>Cliente:</h5>
                              </section>
                              <Select
                                errorField=""
                                name="cliente"
                                placeholder="Selecione um cliente ..."
                                options={clientes}
                                isSearchable
                                isClearable
                                disabled={
                                  loadingOptions ||
                                  loading ||
                                  loadingSubmit ||
                                  initialData.encerrada
                                }
                                fill={false}
                              />
                            </div>
                            <div>
                              <section>
                                <h5>Agência:</h5>
                              </section>
                              <Select
                                errorField=""
                                name="agencia"
                                placeholder="Selecione uma agência ..."
                                options={agencias}
                                isSearchable
                                isClearable
                                disabled={
                                  loadingOptions ||
                                  loading ||
                                  loadingSubmit ||
                                  initialData.encerrada
                                }
                                fill={false}
                              />
                            </div>
                          </ColumnContent>
                        </div>
                      )}
                  </ColumnContent>
                  <ColumnContent columns="3fr 1fr 1fr 1fr">
                    <div>
                      <section>
                        <h5>Setor: *</h5>
                      </section>
                      <Radio
                        // id="setor_id"
                        name="setor"
                        options={[
                          { id: 'hub', label: 'HUB' },
                          { id: 'promo', label: 'PROMO' },
                        ]}
                        handleSelected={value => setSetor(value.id)}
                        disabled={
                          loading || loadingSubmit || initialData.encerrada
                        }
                      />
                    </div>
                    <div>
                      <section>
                        <h5>Gerar versão Web?</h5>
                      </section>
                      <Switch
                        name="web"
                        disabled={
                          loading || loadingSubmit || initialData.encerrada
                        }
                      />
                    </div>
                    <div>
                      <section>
                        <h5>Gerar claquete?</h5>
                      </section>

                      <Switch
                        name="gerarclaquete"
                        disabled={
                          loading || loadingSubmit || initialData.encerrada
                        }
                      />
                    </div>
                    <div>
                      <section>
                        <h5>Arquivar?</h5>
                      </section>

                      <Switch
                        name="arquivo"
                        disabled={
                          loading ||
                          loadingSubmit ||
                          initialData.encerrada ||
                          initialData.statusarquivo !== StatusArquivo.NA
                        }
                      />
                    </div>
                  </ColumnContent>
                  <ColumnContent>
                    <div>
                      <section>
                        <h5>Tipo de Chamada: *</h5>
                      </section>
                      <Radio
                        name="tipo"
                        options={tipos}
                        disabled={
                          loading || loadingSubmit || initialData.encerrada
                        }
                        handleSelected={value => {
                          setTipo(value);
                          if (
                            [
                              Tipo.CHAMADA,
                              Tipo.CAMPANHA,
                              Tipo.AFINACAO,
                              Tipo.PROGRAMETE,
                            ].includes(value.id)
                          ) {
                            if (!formRef.current?.getFieldValue('ancine'))
                              formRef.current?.setFieldValue(
                                'ancine',
                                '1900 10000 10003',
                              );
                          } else if (
                            formRef.current?.getFieldValue('ancine') ===
                            '1900 10000 10003'
                          )
                            formRef.current?.clearField('ancine');
                        }}
                      />
                    </div>
                    <div>
                      <section>
                        <h5>Exibidoras: *</h5>

                        <Button
                          fill
                          color="primary"
                          size="xsm"
                          onClick={e => handleToogleEmissoras(e)}
                        >
                          REDE ? {materialRede ? 'SIM' : 'NÃO'}
                        </Button>
                      </section>
                      <Checkbox
                        name="emissora"
                        options={emissoras}
                        disabled={
                          loadingOptions ||
                          loading ||
                          loadingSubmit ||
                          initialData.encerrada
                        }
                        handleSelected={handleSelectedExibidor}
                      />
                    </div>
                  </ColumnContent>
                  <DadosLocucao>
                    <section>
                      <h5>Dados para Locução:</h5>
                    </section>
                    <ColumnContent columns="1fr 1fr">
                      <Select
                        errorField=""
                        type="avatar"
                        name="comunicador"
                        placeholder="Selecione o comunicador ..."
                        options={comunicadores}
                        isSearchable
                        isClearable
                        disabled={
                          loadingOptions ||
                          loading ||
                          loadingSubmit ||
                          initialData.encerrada
                        }
                        fill={false}
                      />
                      <TextArea
                        name="observacaolocucao"
                        height="38"
                        placeholder="Observações de Locução"
                        icon=""
                        errorField=""
                      />
                    </ColumnContent>
                    {!(tipo.id === Tipo.VINHETA && setor == Setor.PROMO) && (
                      <TextArea
                        name="locucao"
                        height="70"
                        placeholder="Locução: Texto à gravar"
                        icon=""
                        errorField=""
                      />
                    )}
                  </DadosLocucao>
                  {tipo.id &&
                    tipo.id !== Tipo.AFINACAO &&
                    tipo.id !== Tipo.CHAMADA && (
                      <div>
                        <section>
                          <h5>Dados Comerciais:</h5>
                        </section>
                        <ColumnContent columns="1fr 1fr">
                          <Input
                            name="codmaterial"
                            placeholder="Código material de sáida"
                            disabled={
                              loading || loadingSubmit || initialData.encerrada
                            }
                          />
                          <TextArea
                            name="observacaocomercial"
                            height="38"
                            placeholder="Observações Comerciais"
                            icon=""
                            errorField=""
                          />
                        </ColumnContent>
                        {tipo.id === Tipo.VINHETA && setor == Setor.PROMO ? (
                          <Vinheta
                            formRef={formRef}
                            patrocinios={patrocinios}
                            setPatrocinios={setPatrocinios}
                            loadComerciais={loadComerciais}
                            basePrograma={basePrograma}
                            setBasePrograma={setBasePrograma}
                            asyncLoading={asyncLoading}
                          />
                        ) : (
                          <ColumnContent>
                            <div>
                              <AsyncSelectCreatable
                                searchable
                                menuPlacement="top"
                                name="patrocinios"
                                loadOptions={loadComerciais}
                                placeholder="Patrocínios: Buscar por Código de Material"
                                isValidNewOption={(value: string) =>
                                  value.length >= 5 &&
                                  value.length <= 6 &&
                                  Number(value)
                                }
                                onChange={(value: PatrocinioOption[]) =>
                                  setPatrocinios(value)
                                }
                                createOptionPosition="first"
                                type="codmaterial"
                                isClearable
                                isMulti
                                isLoading={asyncLoading}
                                errorField=""
                              />
                            </div>
                            {!!patrocinios && patrocinios.length > 0 && (
                              <div>
                                <section>
                                  <h5>Dados de Bases e Patrocinios:</h5>
                                </section>
                                {patrocinios.map((vi, index) =>
                                  vi.__isNew__ ? (
                                    <DadosPatrocinio>
                                      <p>
                                        {vi.label}
                                        {' - '}
                                        <span>PATROCÍNIO NÃO RECEBIDO</span>
                                      </p>
                                      <MdFiberNew />
                                    </DadosPatrocinio>
                                  ) : (
                                    <DadosPatrocinio>
                                      <p>
                                        {vi.label}
                                        {' - '}
                                        <span>{`${vi.cliente}`}</span>
                                      </p>
                                      <FiInfo id={`id_info_pat${index}`} />
                                      <Tooltip
                                        target={`id_info_pat${index}`}
                                        position="bottom"
                                      >
                                        <p>Duracao: {vi.duracao}</p>
                                        <p>
                                          Agencia: {vi.agencia || 'SEM AGÊNCIA'}
                                        </p>
                                      </Tooltip>
                                    </DadosPatrocinio>
                                  ),
                                )}
                              </div>
                            )}
                          </ColumnContent>
                        )}
                      </div>
                    )}
                  <div>
                    <section>
                      <h5>Ficha Técnica</h5>
                    </section>
                    <TextArea
                      name="fichatecnica"
                      height="150"
                      placeholder="Ficha técnica"
                      icon=""
                      errorField=""
                    />
                  </div>
                </FormContent>
              )}
            </Scroll>
            <FormActions>
              {(initialData.previa || !chamadaId) &&
                profile.setor === Setor.OPEC && (
                  <Button
                    type="submit"
                    disabled={loading || loadingSubmit || initialData.encerrada}
                    color="warn"
                    onClick={() => setPrevia(true)}
                  >
                    {!loadingSubmit ? (
                      'SALVAR PRÉVIA'
                    ) : (
                      <Spinner type="ThreeDots" />
                    )}
                  </Button>
                )}
              {initialData.previa && profile.setor === Setor.OPEC ? (
                <Button
                  type="submit"
                  disabled={loading || loadingSubmit || initialData.encerrada}
                  color="primary"
                >
                  {!loadingSubmit ? (
                    'SALVAR E LIBERAR PRODUÇÃO'
                  ) : (
                    <Spinner type="ThreeDots" />
                  )}
                </Button>
              ) : (
                <Button
                  type="submit"
                  disabled={loading || loadingSubmit || initialData.encerrada}
                  color="primary"
                >
                  {!loadingSubmit ? 'SALVAR' : <Spinner type="ThreeDots" />}
                </Button>
              )}
            </FormActions>
          </Form>
        </Content>
      </Card>
    </Container>
  );
}
